import React, { useEffect, useState } from 'react'
import { result, includes, isUndefined } from 'libraries/lodash'
import Table from './Table'
import { shorten } from 'libraries/front-end-core/services/ShortenerService'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import url from 'libraries/front-end-core/core/url'
import { MW_DEAL_COMPARE } from 'constants/controllers'
import selectAolName from 'redux/selectors/selectAolName'
import { useSelector } from 'react-redux'
import { first } from 'rxjs/operators'

const TableWrapper = ({
  query,
  deals: _deals,
  compareParams,
  comparableParams = {},
  short
}) => {
  const [deals, setDeals] = useState(_deals)
  const aol = useSelector(selectAolName)

  useEffect(() => {
    const { sortBy, sortOrder } = query
    if (!includes(compareParams, sortBy)) {
      setDeals(_deals)
    }

    const deals = [..._deals].sort((a, b) => {
      const aa = parameter(a, sortBy).comparableValue
      const bb = parameter(b, sortBy).comparableValue

      return aa === bb
        ? 0
        : isUndefined(aa)
          ? 1
          : isUndefined(bb)
            ? -1
            : (aa < bb && sortOrder === 'desc') || (aa > bb && sortOrder === 'asc')
                ? -1
                : 1
    })

    setDeals(deals)
  }, [_deals, query.sortBy, query.sortOrder])

  const getParam = (name) => comparableParams[name]

  const handleRemoveDeal = dealId => e => {
    const { show, sortBy, sortOrder } = query
    const dealIds = _deals.reduce((acc, curr) => {
      return (curr.dealId === dealId) ? acc : [...acc, curr.dealId]
    }, [])

    shorten(JSON.stringify({ dealIds, dealType: _deals[0] })).pipe(
      first(shortened => shortened !== RESPONSE_PENDING)
    ).subscribe(short => {
      replaceUrl(url(
        MW_DEAL_COMPARE,
        { short, aol },
        {
          show,
          ...(sortBy && { sortBy }),
          ...(sortOrder && { sortOrder })
        }
      ))
    })
  }

  const parameter = (deal, paramName) => {
    const config = result(
      comparableParams,
      [paramName, 'deals', deal.dealId],
      null
    )
    const param = deal.getParam(paramName)

    return param.extend({ config })
  }

  return (
    <Table
      {...{
        deals,
        compareParams,
        getParam,
        sortBy: query.sortBy,
        sortOrder: query.sortOrder,
        handleRemoveDeal,
        parameter,
        short
      }}
    />
  )
}

export default TableWrapper
